import { useMemo } from 'react';

import { useNavigate } from 'react-router-dom';

import { ProjectSummary } from 'types';
import useModal from 'hooks/useModal';
import ProjectCopyModal from 'components/modals/ProjectCopyModal/ProjectCopyModal';
import ProjectDeleteModal from 'components/modals/ProjectDeleteModal/ProjectDeleteModal';
import { calcTimeGapToNowInKorean } from 'utils/commonUtils';

interface UseProjectCardProps {
  project: ProjectSummary;
  projectsRefetch: () => void;
}

const useProjectCard = ({ project, projectsRefetch }: UseProjectCardProps) => {
  const navigate = useNavigate();

  const modal = useModal();
  const timeGap = useMemo(() => calcTimeGapToNowInKorean(new Date(project.updateDate)), [project.updateDate]);

  const handleProjectCardClick = () => {
    navigate(`/${project.ownerName}/${project.projectName}`);
  };

  const handleMenuButtonClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDeleteButtonClick = () => {
    modal.render({
      key: 'projectDelete',
      modal: <ProjectDeleteModal ownerName={project.ownerName} projectName={project.projectName} />,
    });
  };

  const handleCopyButtonClick = () => {
    modal.render({
      key: 'projectCopy',
      modal: (
        <ProjectCopyModal
          projectName={project.projectName}
          ownerName={project.ownerName}
          projectsRefetch={projectsRefetch}
        />
      ),
    });
  };

  return {
    timeGap,
    url: `/workspace/${project.ownerName}/${project.projectName}`,
    onProjectCardClick: handleProjectCardClick,
    onMenuButtonClick: handleMenuButtonClick,
    onDeleteButtonClick: handleDeleteButtonClick,
    onCopyButtonClick: handleCopyButtonClick,
  };
};

export default useProjectCard;
